import { GraphQLAuthMode } from "@aws-amplify/core/dist/esm/libraryUtils";

export const environment = {
  version: require('../../package.json').version,
  production: true,
  prefixVersion: 'D',
  name: 'DEMO',
  locale: 'en',
  homeRoot: '/dashboard',
  providers: {
    api: {
      url: 'https://suttons.thelogchain.com/api',
      auth: {
        type: 'Bearer',
      },
    },
  },
  LANGUAGE: {
    Default: 'en',
    Support: ['en', 'es', 'ja', 'zh'],
  },
  AWS_CONFIG: {
    Auth: {
      Cognito: {
        identityPoolId: 'ap-southeast-1:08e439d1-0644-4bf9-822e-80bb1295640e',
        region: 'ap-southeast-1',
        userPoolId: 'ap-southeast-1_AhhVtoC60',
        userPoolClientId: '53up024tnc2sodsbrh0qoth3ba',
      },
    },
    Storage: {
      S3: {
        bucket: 'logchain-staging-d', //REQUIRED -  Amazon S3 bucket name
        region: 'ap-southeast-1', //OPTIONAL -  Amazon service region
        apiVersion: '2006-03-01',
      },
      customPrefix: {
        public: '', // we want to customize the prefix.
      },
    },
    API: {
      GraphQL: {
        endpoint:
          'https://fqlqvkky75dslpg76v7s4y6jea.appsync-api.ap-southeast-1.amazonaws.com/graphql',
        region: 'ap-southeast-1',
        defaultAuthMode: 'userPool' as GraphQLAuthMode,
      },
    },
  },
  google_api_key: 'AIzaSyD1upPg36BJSXySxBF-0vOHjY0sUpS8t_E',
  firebase: {
    apiKey: 'AIzaSyD_Sa3uVPi8tplwkY8KXfNrbdqdPYd-n6Q',
    authDomain: 'lc-dev-be9e8.firebaseapp.com',
    projectId: 'lc-dev-be9e8',
    databaseURL: 'https://lc-dev-be9e8.firebaseio.com',
    storageBucket: 'lc-dev-be9e8.appspot.com',
    messagingSenderId: '493108013284',
    appId: '1:493108013284:web:8642dc75350a15e80164f1',
    measurementId: 'G-Z4DM68HGZ5',
  },
};
